import {List, Map} from 'immutable';

import {myRemoveEntitiesBySport} from './utils';

import {LIVE_INIT, LIVE_UPDATE, TIMETABLE_INIT, TIMETABLE_UPDATE} from 'sagas/actions';

import * as LiveActions from 'actions/Live';
import * as LineActions from 'actions/Line';
import * as TimeTableActions from 'actions/Timetable';
import * as FavouritesActions from 'actions/Favourites';
import * as MatchResultActions from 'actions/MatchResults';
import * as StakeOfTheDayActions from 'actions/StakeOfTheDay';
import * as PopularActions from 'actions/Popular';

import * as FavouriteState from 'constants/FavouriteState';

export default function sportsReducer(sports, action) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
        case LineActions.CLEAR_LINE:
        case TimeTableActions.CLEAR_TIME_TABLE:
        case MatchResultActions.FETCH_MATCH_RESULTS:
        case MatchResultActions.FAILURE_FETCH_MATCH_RESULTS:
            return new Map();

        case LIVE_INIT.SUCCESS:
        case TIMETABLE_INIT.SUCCESS:
        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
            return init(new Map(), action.data);

        case LIVE_UPDATE.SUCCESS:
        case TIMETABLE_UPDATE.SUCCESS:
            return update(sports, action.data);

        case FavouritesActions.TOGGLE_FAVOURITE_SPORT:
            return toggleFavouriteSport(sports, action.data);

        case FavouritesActions.TOGGLE_FAVOURITE_LEAGUE:
            return toggleFavouriteLeagueSport(sports, action.data);

        case FavouritesActions.TOGGLE_FAVOURITE_MATCH:
            return toggleFavouriteMatchSport(sports, action.data);
    }

    return sports;
}

function init(sports, data) {
    if (data.sports !== undefined) {
        sports = addSports(sports, data.sports.add);
    }
    if (data.leagues !== undefined) {
        sports = addSportsLeagues(sports, data.leagues.add);
    }
    if (data.events !== undefined) {
        sports = addSportsMatches(sports, data.events.add);
    }

    return sports;
}

function update(sports, data) {
    if (data.sports !== undefined) {
        //sports = removeEntities(sports, 'id', data.sports.remove);
        sports = myRemoveEntitiesBySport(sports, 'id', data.sports.remove);
        sports = addSports(sports, data.sports.add);
        sports = changeSports(sports, data.sports.change);
    }

    if (data.leagues !== undefined) {
        //sports = removeSportLeagues(sports, data.leagues.remove);
        sports = myRemoveSportLeagues(sports, data.leagues.remove);
        sports = sportFavouriteStateChangeOnLeaguesRemove(sports, data.leagues.remove);

        sports = addSportsLeagues(sports, data.leagues.add);
        sports = sportFavouriteStateChangeOnLeaguesAdd(sports, data.leagues.add);
    }

    if (data.events !== undefined) {
        //sports = removeSportMatches(sports, data.events.remove);
        sports = myRemoveSportMatches(sports, data.events.remove);
        sports = sportFavouriteStateChangeOnMatchesRemove(sports, data.events.remove);

        sports = addSportsMatches(sports, data.events.add);
        sports = sportFavouriteStateChangeOnMatchesAdd(sports, data.events.add);
    }

    return sports;
}

function addSports(sports, addSports) {
    if (addSports === undefined) {
        return sports;
    }

    sports = sports.withMutations(s => {
        for (let i = 0; i < addSports.length; i++) {
            let sport = new Map(addSports[i]);
            sport = sport.set('leagues', new List());
            sport = sport.set('leagueMatches', new Map());
            sport = sport.set('favouriteLeagueMatches', new Map());
            sport = sport.set('favouriteState', FavouriteState.NONE);

            s.set(sport.get('id'), sport);
        }
    });

    return sports;
}

function changeSports(sports, changedSports) {
    if (changedSports === undefined) {
        return sports;
    }

    for (let i = 0; i < changedSports.length; i++) {
        const sport = changedSports[i];

        sports = sports.updateIn([sport.id, 'name'], () => {return sport.name});
        sports = sports.updateIn([sport.id, 'priority'], () => {return sport.priority});
    }

    return sports;
}

function addSportsLeagues(sports, addLeagues) {
    if (addLeagues === undefined) {
        return sports;
    }

    for (let i = 0; i < addLeagues.length; i++) {
        const sportId = addLeagues[i].sportId;
        const leagueId = addLeagues[i].id;

        (function (sportId, leagueId) {
            sports = sports.updateIn([sportId, 'leagues'], l => l.push(leagueId));
            sports = sports.updateIn([sportId, 'leagueMatches'], l => l.set(leagueId, new List()));
        })(sportId, leagueId);
    }

    return sports;
}

function addSportsMatches(sports, addMatches) {
    if (addMatches === undefined) {
        return sports;
    }

    for (let i = 0; i < addMatches.length; i++) {
        const sportId = addMatches[i].sportId;
        const leagueId = addMatches[i].leagueId;
        const matchId = addMatches[i].id;

        (function (sportId, leagueId, matchId) {
            sports = sports.updateIn([sportId, 'leagueMatches', leagueId], l => l.push(matchId));
        })(sportId, leagueId, matchId);
    }

    return sports;
}

function myRemoveSportLeagues(sports, removeLeagues) {
    if (removeLeagues === undefined) {
        return sports;
    }

    for (let i = 0; i < removeLeagues.length; i++) {
        const sportId = removeLeagues[i].sportId;
        const leagueId = removeLeagues[i].id;

        let leagues = sports.getIn([sportId, 'leagues']);
        if (leagues !== undefined) {
            leagues = leagues.filter(lId => (lId != leagueId));
        }
        sports = sports.setIn([sportId, 'leagues'], leagues);

        let leagueMatches = sports.getIn([sportId, 'leagueMatches']);
        if (leagueMatches !== undefined) {
            leagueMatches = leagueMatches.filter((matches, lId) => (lId != leagueId));
        }
        sports = sports.setIn([sportId, 'leagueMatches'], leagueMatches);

        let favouriteLeagueMatches = sports.getIn([sportId, 'favouriteLeagueMatches']);
        if (favouriteLeagueMatches !== undefined) {
            favouriteLeagueMatches = favouriteLeagueMatches.filter((matches, lId) => (lId != leagueId));
        }
        sports = sports.setIn([sportId, 'favouriteLeagueMatches'], favouriteLeagueMatches);
    }

    return sports;
}

function myRemoveSportMatches(sports, removeMatches) {
    if (removeMatches === undefined) {
        return sports;
    }

    for (let i = 0; i < removeMatches.length; i++) {
        const sportId = removeMatches[i].sportId;
        const leagueId = removeMatches[i].leagueId;
        const matchId = removeMatches[i].id;

        let matches = sports.getIn([sportId, 'leagueMatches', leagueId]);
        if (matches !== undefined) {
            matches = matches.filter(mId => (mId != matchId));
        }
        sports = sports.setIn([sportId, 'leagueMatches', leagueId], matches);

        let favouriteMatches = sports.getIn([sportId, 'favouriteLeagueMatches', leagueId]);
        if (favouriteMatches !== undefined) {
            favouriteMatches = favouriteMatches.filter(mId => (mId != matchId));
        }

        if (favouriteMatches === undefined || !favouriteMatches || !favouriteMatches.size) {
            sports = sports.removeIn([sportId, 'favouriteLeagueMatches', leagueId]);
        } else {
            sports = sports.setIn([sportId, 'favouriteLeagueMatches', leagueId], favouriteMatches);
        }
    }

    return sports;
}

function toggleFavouriteSport(sports, sport) {
    return sports.updateIn([sport.get('id')], s => {
        const favouriteState = s.get('favouriteState') === FavouriteState.FULL
            ? FavouriteState.NONE
            : FavouriteState.FULL;

        s = s.set('favouriteState', favouriteState);

        if (favouriteState === FavouriteState.FULL) {
            return s.set('favouriteLeagueMatches', s.get('leagueMatches'));
        } else {
            return s.set('favouriteLeagueMatches', new Map());
        }
    });
}

function toggleFavouriteLeagueSport(sports, league) {
    const sportId = league.get('sportId');
    const leagueFavouriteState = league.get('favouriteState');

    const leagueId = league.get('id');

    if (leagueFavouriteState === FavouriteState.FULL) {
        sports = sports.updateIn([sportId, 'favouriteLeagueMatches'], l => {
            return l.delete(leagueId);
        });
    } else {
        const leagueMatches = sports.getIn([sportId, 'leagueMatches', leagueId]);
        sports = sports.updateIn([sportId, 'favouriteLeagueMatches'], l => l.set(leagueId, leagueMatches));
    }

    let sportFavouriteState = FavouriteState.FULL;

    const sportLeagues = sports.getIn([sportId, 'leagues']);
    const sportFavouriteLeagues = sports.getIn([sportId, 'favouriteLeagueMatches']).keySeq();

    if (sportFavouriteLeagues.size === 0) {
        sportFavouriteState = FavouriteState.NONE;
    } else if (sportFavouriteLeagues.size < sportLeagues.size) {
        sportFavouriteState = FavouriteState.PARTIAL;
    }

    return sports.updateIn([sportId], l => {
        return l.set('favouriteState', sportFavouriteState);
    });
}

function toggleFavouriteMatchSport(sports, match) {
    const sportId = match.get('sportId');
    const leagueId = match.get('leagueId');
    const matchId = match.get('id');

    const matchFavouriteState = match.get('favouriteState');

    if (matchFavouriteState === FavouriteState.NONE) {
        if (sports.getIn([sportId, 'favouriteLeagueMatches', leagueId]) === undefined) {
            sports = sports.updateIn([sportId, 'favouriteLeagueMatches'], l => l.set(leagueId, new List()));
        }

        sports = sports.updateIn([sportId, 'favouriteLeagueMatches', leagueId], m => m.push(matchId));
    } else {
        sports = sports.updateIn([sportId, 'favouriteLeagueMatches', leagueId], m => {
            const index = m.indexOf(matchId);
            return m.remove(index);
        });

        if (sports.getIn([sportId, 'favouriteLeagueMatches', leagueId]).size === 0) {
            sports = sports.updateIn([sportId, 'favouriteLeagueMatches'], l => {
                return l.delete(leagueId);
            });
        }
    }

    const sportLeagues = sports.getIn([sportId, 'leagues']);
    const sportFavouriteLeagues = sports.getIn([sportId, 'favouriteLeagueMatches']).keySeq();

    let sportFavouriteState = FavouriteState.FULL;

    if (sportFavouriteLeagues.size === 0) {
        sportFavouriteState = FavouriteState.NONE;
    } else if (sportFavouriteLeagues.size < sportLeagues.size) {
        sportFavouriteState = FavouriteState.PARTIAL;
    }

    return sports.updateIn([sportId], l => {
        return l.set('favouriteState', sportFavouriteState);
    });
}

function sportFavouriteStateChangeOnLeaguesAdd(sports, newLeagues) {
    if (newLeagues === undefined) {
        return sports;
    }

    for (let i = 0; i < newLeagues.length; i++) {
        const league = newLeagues[i];
        const sportId = league.sportId;

        const sportFavouriteState = sports.getIn([sportId, 'favouriteState']);

        sports = sports.updateIn([sportId], s => {
            return s.set('favouriteState', sportFavouriteState === FavouriteState.FULL
                ? FavouriteState.PARTIAL
                : sportFavouriteState);
        });
    }

    return sports;
}

function sportFavouriteStateChangeOnLeaguesRemove(sports, removeLeagues) {
    if (removeLeagues === undefined) {
        return sports;
    }

    for (let i = 0; i < removeLeagues.length; i++) {
        const league = removeLeagues[i];
        const sportId = league.sportId;

        const sportLeagues = sports.getIn([sportId, 'leagues']);
        const sportFavouriteLeagues = sports.getIn([sportId, 'favouriteLeagueMatches']).keySeq();

        let sportFavouriteState = FavouriteState.FULL;

        if (sportFavouriteLeagues.size === 0) {
            sportFavouriteState = FavouriteState.NONE;
        } else if (sportFavouriteLeagues.size < sportLeagues.size) {
            sportFavouriteState = FavouriteState.PARTIAL;
        }

        sports = sports.updateIn([sportId], s => {
            return s.set('favouriteState', sportFavouriteState === FavouriteState.FULL
                ? FavouriteState.PARTIAL
                : sportFavouriteState);
        });
    }

    return sports;
}

function sportFavouriteStateChangeOnMatchesAdd(sports, newMatches) {
    if (newMatches === undefined) {
        return sports;
    }

    for (let i = 0; i < newMatches.length; i++) {
        const match = newMatches[i];
        const sportId = match.sportId;

        const sportFavouriteState = sports.getIn([sportId, 'favouriteState']);

        sports = sports.updateIn([sportId], s => {
            return s.set('favouriteState', sportFavouriteState === FavouriteState.FULL
                ? FavouriteState.PARTIAL
                : sportFavouriteState);
        });
    }

    return sports;
}

function sportFavouriteStateChangeOnMatchesRemove(sports, removeMatches) {
    if (removeMatches === undefined) {
        return sports;
    }

    for (let i = 0; i < removeMatches.length; i++) {
        const match = removeMatches[i];
        const sportId = match.sportId;

        const sportLeagues = sports.getIn([sportId, 'leagues']);
        const sportFavouriteLeagues = sports.getIn([sportId, 'favouriteLeagueMatches']).keySeq();

        let sportFavouriteState = FavouriteState.FULL;

        if (sportFavouriteLeagues.size === 0) {
            sportFavouriteState = FavouriteState.NONE;
        } else if (sportFavouriteLeagues.size < sportLeagues.size) {
            sportFavouriteState = FavouriteState.PARTIAL;
        }

        sports = sports.updateIn([sportId], s => {
            return s.set('favouriteState', sportFavouriteState === FavouriteState.FULL
                ? FavouriteState.PARTIAL
                : sportFavouriteState);
        });
    }

    return sports;
}


// WEBPACK FOOTER //
// ./js/shared/reducers/entities/sportsReducer.js